// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-bar[data-v-7154dd57] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.buttons-bottom[data-v-7154dd57] {\n  display: flex;\n  justify-content: center;\n}\n.upsert-buttons-holder[data-v-7154dd57] {\n  display: flex;\n}\n.upsert-buttons-holder > *[data-v-7154dd57] {\n  margin: 0px 5px 0px 5px;\n}\n", ""]);
// Exports
module.exports = exports;
